export const getAuthUser = state => state.auth.currentUser;
